import { skipToken, useQuery } from '@tanstack/react-query';

import { ContextSources } from '@air/api';
import { callAirApi } from '@air/utils-api';

export const PRIVATE_CONTEXT_SOURCES_LIST_KEY = 'PRIVATE_CONTEXT_SOURCES_LIST';

export type PrivateContextSourcesListKey = [
  typeof PRIVATE_CONTEXT_SOURCES_LIST_KEY,
  UsePrivateContextSourcesListParams,
];

export const getPrivateContextSourcesListKey = (
  params: UsePrivateContextSourcesListParams,
): PrivateContextSourcesListKey => {
  return [PRIVATE_CONTEXT_SOURCES_LIST_KEY, params];
};

export type UsePrivateContextSourcesListParams = Omit<Parameters<typeof ContextSources.list>[0], 'workspaceId'> & {
  workspaceId: string | undefined;
};

export type UsePrivateContextSourcesListOptions = {
  enabled?: boolean;
};

export const usePrivateContextSourcesList = (
  params: UsePrivateContextSourcesListParams,
  options?: UsePrivateContextSourcesListOptions,
) => {
  const { workspaceId } = params;

  return useQuery({
    queryKey: getPrivateContextSourcesListKey(params),
    queryFn: !workspaceId ? skipToken : () => callAirApi(() => ContextSources.list({ ...params, workspaceId })),
    enabled: !!workspaceId && options?.enabled,
  });
};
